module.exports = __webpack_public_path__ + "img/nikolai-lockertsen-office.b0b3b36.jpg";